/** @jsxImportSource @emotion/react */

import React, { FC, useState } from 'react'
import { createSearchParams, useLocation, useSearchParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import { RouteValue, useLink } from 'routes/cmsRoutes'
import { TabsItem } from 'types/tabsItem'
import TabsNavigation from 'components/TabsNavigation'
import { TemplateList } from '../TemplateList'
import { QUERY_PARAM, QUESTION_TEMPLATES_TAB, QUESTIONS_TAB, TABS } from '../../Questions/QuestionTabs'
import * as classes from './styles'
import { QuestionPassageList } from './QuestionPassageList'

export const List: FC = () => {
  const location = useLocation()
  const { navigate } = useLink()
  const [searchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)

    return TABS.find(({ id }) => id === tabId) || QUESTIONS_TAB
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    navigate(location.pathname as RouteValue, undefined, {
      searchParams: createSearchParams({ [QUERY_PARAM]: activeTab.id }),
    })
    setActiveTab(activeTab)
  }

  const renderTitle = () => {
    if (activeTab.id === QUESTIONS_TAB.id) {
      return 'CARS Questions'
    }

    if (activeTab.id === QUESTION_TEMPLATES_TAB.id) {
      return 'CARS Question Templates'
    }

    return null
  }

  const renderTab = () => {
    if (activeTab.id === QUESTIONS_TAB.id) {
      return <QuestionPassageList />
    }

    if (activeTab.id === QUESTION_TEMPLATES_TAB.id) {
      return <TemplateList />
    }

    return null
  }

  return (
    <section css={classes.wrapper}>
      <Typography css={classes.title} variant="title3">
        {renderTitle()}
      </Typography>

      <TabsNavigation css={classes.tabs} tabs={TABS} value={activeTab} onChange={handleChangeTab} />

      {renderTab()}
    </section>
  )
}
